import React, {useEffect, useState} from "react";
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import {ProfilePicture} from "../common/ProfilePicture";
import {alpha, Input, Stack, Switch, TextField, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {Icon} from "@iconify/react";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import services from "../../services";
import CircularProgress from "@mui/material/CircularProgress";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {User,updateUser} from "../../app/features/Auth";

const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: "#089BAB",
        '&:hover': {
            backgroundColor: "none",
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: "#089BAB",
    },
}));

interface editProfile {
                "id": number,
                "first_name": string,
                "last_name": string,
                "email": string,
                "dob": string,
                "password": string,
                "role_id": number,
                "createdAt": string,
                "updatedAt": string
}

interface EditProfile {
    handleClose : ()=>void
}

export const EditProfile = ({handleClose}:EditProfile) =>{

    const _user = useSelector(((state:RootState) => state.auth.user))

    const dispatch = useDispatch()

    const [user, setUser] = useState<User>(_user ? _user :
        {
            id : 0,
            first_name: "",
            last_name : "",
            email : "",
            dob : "",
            userID:""
        }
    )

    const [wasOpened, setWasOpened] = useState<boolean>(false);

    const [loader,setLoader] = useState<boolean>(false)

    const [validationDate,setValidationDate] = useState({message: '',error:false})

    const getAge = (dateString : string)  =>{
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }


    const OnDateChange = (newValue:Date) => {

        if(newValue === null)
            return false

        if(wasOpened){
            setUser((prevState : User) => {
                return {...prevState,dob:newValue.toISOString().split('T')[0]!}
            })
        }
        else{
            var timestamp = Date.parse(newValue !==null ? newValue.toString() : '');

            if(newValue > new Date()){
                setValidationDate({message: 'red',error:true})
                return false
            }

            if (isNaN(timestamp) == false) {
                setValidationDate({message: '',error:false})
                let date = new Date(newValue.setDate(newValue.getDate() + 1))
                setUser(prevState => {
                    return {...prevState,dob:date.toISOString().split('T')[0]!}
                })

            }
        }
    }


    const handleEdit = () =>{

        if(validationDate.error)
            return false

        setLoader(true)
        services
            .UpdateUser({first_name:user.first_name,last_name:user.last_name,dob:user.dob},user.id)
            .then(res=>{
                setLoader(false)
                localStorage.setItem('user',JSON.stringify(user))
                dispatch(updateUser(user))
                handleClose()
            })
            .catch(error=>{
                setLoader(false)
            })
    }

    const setSlider = (action : boolean,field : string) =>{
        setUser(prevState => {
            return {...prevState,[field] : action}
        })
    }

    const handleInputChange = (e : React.ChangeEvent<HTMLInputElement>) =>{
        setUser(prevState => {
            return { ...prevState, [e.target.name] : e.target.value }
        })
    }

    return(
        <Box sx={{ flexGrow:1 }}>
            <Grid container rowSpacing={3} spacing={3} sx={{width:{sm:300,lg:900}}}>
                <Grid item md={6}>
                    <Stack direction={"row"} alignItems={"center"} spacing={1}>
                        <ProfilePicture/>
                        <Typography fontSize={32} fontWeight={700}>{user.first_name} {user.last_name}</Typography>
                    </Stack>
                </Grid>
                <Grid container   item md={6} alignItems={"flex-end"}>
                    <Stack width={"100%"} spacing={-1}>
                        <Typography color={"#081735"} fontSize={18} fontWeight={700}>
                            EMAIL ALERTS
                        </Typography>
                                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                    <Typography fontSize={14} fontWeight={400} color={"#081735"} >
                                        ON NEW MEASURMENTS
                                    </Typography>
                                    <GreenSwitch
                                        // checked={user?.notificationOnNewMeasurements}
                                                  name={"notificationOnNewMeasurements"}
                                                  // onChange={(e)=>setSlider(!user?.notificationOnNewMeasurements,e.target.name)}
                                    />
                                </Stack>

                                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                                        ON ABNORMAL VALUES
                                    </Typography>
                                    <GreenSwitch
                                        // checked={user?.notificationOnAbnormalValues}
                                                  name={"notificationOnAbnormalValues"}
                                                  // onChange={(e)=>setSlider(!user?.notificationOnAbnormalValues,e.target.name)}
                                    />
                                </Stack>

                    </Stack>
                </Grid>


                <Grid item md={6}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        FIRST NAME
                    </Typography>
                    <input value={user?.first_name} className={"edit-profile-inputs"} name={"first_name"} onChange={handleInputChange} />
                </Grid>
                <Grid item md={6}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        LAST NAME
                    </Typography>
                    <input value={user?.last_name} className={"edit-profile-inputs"} name="last_name" onChange={handleInputChange} />
                </Grid>



                <Grid item width={"100%"}>
                    <Stack spacing={2}>
                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            Email
                        </Typography>
                        <input disabled={true} value={user?.email} name={"email"} className={"edit-profile-inputs"}/>
                    </Stack>
                </Grid>


                <Grid item md={6}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        DOB
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label="Custom input"
                            value={user.dob}
                            maxDate={new Date()}
                            onChange={(newValue) => {
                                OnDateChange(newValue!)
                            }}
                            // onError={()=>console.log("error")}
                            autoFocus={true}
                            onOpen={()=>setWasOpened(true)}
                            onClose={()=>setWasOpened(false)}
                            inputFormat={"dd/MM/yyyy"}
                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background:"#FFFFFF",
                                    padding:"0px 10px",
                                    borderRadius:"12px",
                                    height:"40px",
                                    border:validationDate.message.length>0 ? "2px solid red" : "2px solid #E6E8F0",
                                    justifyContent:"space-between"
                                }}>
                                    <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                    {InputProps?.endAdornment}
                                </Box>
                            )}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item md={6}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        Age
                    </Typography>
                    <input value={getAge(user.dob)} disabled={true} className={"edit-profile-inputs"} />
                </Grid>

                <Grid item width={"100%"} display={"flex"} justifyContent={"flex-end"}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        sx={{
                            borderRadius:"16px",
                            textTransform:"none",
                            color:"#8F95B2",
                            fontWeight:700,
                            boxShadow:"none",
                            padding:1,
                            fontSize : "16px",
                            border:"1px solid #8F95B2"
                        }}>CANCEL</Button>
                    <Button
                        onClick={()=>{handleEdit()}}
                        variant="contained"
                        sx={{
                            borderRadius:"16px",
                            background:"#089BAB",
                            textTransform:"none",
                            color:"#F9FAFC",
                            fontWeight:700,
                            boxShadow:"none",
                            padding:1,
                            fontSize : "16px",
                            marginLeft:"10px",
                            width:100
                        }}>SAVE
                        <CircularProgress sx={{position:"relative",left:"10px",color:"#FFFFFF",display:loader?" ":"none"}} size={25} thickness={6}/>
                    </Button>
                </Grid>

            </Grid>

        </Box>
    )
}